import { useLocation } from "react-router-dom"

import { WhatsNewDialog } from "@/features/whats-new/components/whats-new-dialog"

import { useOnboardingOverlayActive } from "../onboarding-overlay-context"

export function OnboardingAwareWhatsNewDialog() {
  const location = useLocation()
  const onboardingActive = useOnboardingOverlayActive()
  const trainingHandoff = new URLSearchParams(location.search).get("onboarding") === "1"
  if (onboardingActive || trainingHandoff) return null
  return <WhatsNewDialog />
}
